import http from './http'
import cookies from 'vue-cookies'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://transfer.backend-pier.com'

/**
 * Создание заказа трансфера
 * @param {number} robuxAmount - Количество робуксов
 * @param {string} placeId - ID места
 * @param {string} universeId - ID вселенной
 * @param {string} username - Имя пользователя
 * @param {string} promoCode - Промокод (опционально)
 * @param {boolean} flag - Флаг: true для transfer/depot, false для обычного пополнения
 * @returns {Promise<any|null>} Данные заказа или null при ошибке
 */
export const makeOrderTransfer = async (
  robuxAmount,
  placeId,
  universeId,
  username,
  promoCode = '',
  flag = true
) => {
  try {
    const params = new URLSearchParams({
      robux_amount: robuxAmount,
      place_id: placeId,
      universe_id: universeId,
      username,
      flag: flag
    })

    if (promoCode) {
      params.append('promo', promoCode)
    }

    const url = `${API_BASE_URL}/make_order?${params.toString()}`
    const accessToken = cookies.get('access_token')
    const response = await http.get(url, accessToken)

    if (response.statusCode === 200) {
      return response.data
    }

    return null
  } catch (error) {
    console.error('Error in makeOrderTransfer:', error)
    return null
  }
}

/**
 * Создание заказа SuperPass
 * @param {string} superPassId - ID SuperPass
 * @param {string} username - Имя пользователя
 * @param {boolean} flag - Флаг: true для transfer/depot, false для обычного пополнения
 * @param {string} currency - Валюта (например, 'RUB', 'USD')
 * @returns {Promise<{data: any, error: string}|null>} Данные заказа с возможной ошибкой или null
 */
export const makeOrderSuperPass = async (
  superPassId,
  username,
  flag = true,
  currency = 'RUB'
) => {
  try {
    const params = new URLSearchParams({
      superpass_id: superPassId,
      username,
      flag: flag,
      currency: currency
    })

    const url = `${API_BASE_URL}/make_superpass_order_new_new?${params.toString()}`
    const accessToken = cookies.get('access_token')
    const response = await http.get(url, accessToken)

    if (response.statusCode === 200 || response.statusCode === 201) {
      const { data, order } = response.data
      let errorMessage = ''

      // Проверяем успешный ответ: либо status === true, либо есть order (для 201)
      if (response.data.status === true || (order && order._id)) {
        // Успешный ответ - возвращаем структуру как для Transfer
        return {
          status: true,
          order: order,
          data: order
        }
      } else if (data && data.includes && data.includes(4)) {
        errorMessage = 'Недостаточно средств на балансе'
      } else if (data && data.includes && data.includes(5)) {
        errorMessage = 'Вы не авторизованы'
      } else if (data && data.includes && data.includes(1)) {
        errorMessage = 'Ошибка на сервере'
      } else if (data && data.includes && data.includes(6)) {
        errorMessage = 'Количество робаксов недоступно для покупки'
      }

      // Ошибка - возвращаем структуру с ошибкой
      return {
        status: false,
        error: errorMessage,
        data: data
      }
    }

    return null
  } catch (error) {
    console.error('Error in makeOrderSuperPass:', error)
    return null
  }
}

/**
 * Создание платежа для заказа
 * @param {string} orderId - ID заказа
 * @param {string} userId - ID пользователя
 * @param {number} amount - Сумма платежа
 * @param {string} paymentType - Тип платежа (например, 'card', 'sbp')
 * @param {string} paymentSystem - Платежная система (например, 'cardlink', 'lava')
 * @param {string} email - Email (опционально)
 * @param {string} currency - Валюта (например, 'rub', 'usd')
 * @returns {Promise<{id: string, redirect_uri: string}|null>} Данные платежа с redirect_uri или null при ошибке
 */
export const createPayment = async (
  orderId,
  userId,
  amount,
  paymentType,
  paymentSystem,
  email = '',
  currency = 'rub'
) => {
  try {
    const PAYMENT_API_URL = process.env.VUE_APP_PAYMENT_API_URL || 'https://payments.backend-pier.com/api/v1'

    const body = {
      amount: amount,
      paymentSystem: paymentSystem,
      currency: currency.toLowerCase(),
      email: email,
      payment_type: paymentType,
      salesOrderId: orderId
    }

    const url = `${PAYMENT_API_URL}/topups/create`
    const accessToken = cookies.get('access_token')
    const response = await http.post(url, body, accessToken)

    if ((response.statusCode === 200 || response.statusCode === 201) && response.data) {
      return response.data
    }

    return null
  } catch (error) {
    console.error('Error in createPayment:', error)
    return null
  }
}
